
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRight, LucideIcon } from 'lucide-react';

interface ValorisationServiceCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  path: string;
  color: string;
  benefits: string[];
}

const ValorisationServiceCard: React.FC<ValorisationServiceCardProps> = ({
  title,
  description,
  icon: IconComponent,
  path,
  color,
  benefits
}) => {
  return (
    <Card className="group hover:shadow-xl transition-all duration-300 border-0 shadow-lg h-full flex flex-col">
      <CardHeader className="pb-4 flex-shrink-0">
        <div className={`w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 ${color} rounded-xl flex items-center justify-center mb-3 md:mb-4 group-hover:scale-110 transition-transform mx-auto sm:mx-0`}>
          <IconComponent className="h-6 w-6 sm:h-7 sm:w-7 md:h-8 md:w-8 text-white" />
        </div>
        <CardTitle className="text-xl sm:text-xl md:text-2xl text-fabre-gray group-hover:text-fabre-green transition-colors text-center sm:text-left">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 flex-grow flex flex-col">
        <CardDescription className="text-gray-600 text-sm sm:text-base leading-relaxed text-center sm:text-left">
          {description}
        </CardDescription>
        
        <div className="space-y-2 flex-grow">
          <h4 className="font-semibold text-fabre-gray text-sm md:text-base text-center sm:text-left">Avantages clés :</h4>
          <ul className="space-y-1">
            {benefits.map((benefit, index) => (
              <li key={index} className="flex items-start text-xs sm:text-sm text-gray-600">
                <ArrowRight className="h-3 w-3 text-fabre-green mr-2 mt-0.5 flex-shrink-0" />
                <span className="leading-relaxed">{benefit}</span>
              </li>
            ))}
          </ul>
        </div>

        <Button asChild className="w-full mt-4 md:mt-6 bg-fabre-green hover:bg-fabre-darkgreen text-sm md:text-base py-2 md:py-3">
          <Link to={path} className="flex items-center justify-center">
            En savoir plus <ArrowRight className="ml-2 h-3 w-3 md:h-4 md:w-4" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
};

export default ValorisationServiceCard;
